import { useState, useEffect } from "react";
import throttle from "lodash.throttle";

const findKeyByValue = (object, value) =>
  Object.keys(object).find((key) => object[key] === value);

const getDeviceConfig = (width) => {
  const screens = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  };

  const bpSizes = Object.keys(screens).map((screenSize) =>
    parseInt(screens[screenSize])
  );

  const bpShapes = bpSizes.map((size, index) => ({
    min: !index ? 0 : bpSizes[index - 1],
    max: size,
    key: findKeyByValue(screens, `${size}px`),
  }));

  let breakpoint = null;

  bpShapes.forEach((shape) => {
    if (!shape.min && width < shape.max) {
      breakpoint = shape.key;
    } else if (width >= shape.min && width < shape.max) {
      breakpoint = shape.key;
    } else if (!shape.max && width >= shape.max) {
      breakpoint = shape.key;
    }
  });

  return breakpoint;
};

const useTailwindBreakpoint = () => {
  const width = typeof window !== "undefined" ? window.innerWidth : 0;

  const [brkPnt, setBrkPnt] = useState(() => getDeviceConfig(width));

  useEffect(() => {
    const calcInnerWidth = throttle(() => {
      setBrkPnt(
        getDeviceConfig(typeof window !== "undefined" ? window.innerWidth : 0)
      );
    }, 800);
    window.addEventListener("resize", calcInnerWidth);
    return () => window.removeEventListener("resize", calcInnerWidth);
  }, []);

  return brkPnt;
};

export default useTailwindBreakpoint;
